// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   Box, TextField, Stack, Button, FormControl, IconButton, Grid,
//   Typography, Paper
// } from '@mui/material';
// import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
// import { Formik } from 'formik';
// import { LoadingButton } from '@mui/lab';
// import '../../index.css';
// import basicSchema from "./validation";
// import { ForgotPasswordRequest } from '../../store/reducers/LoginReducer';
// import toast from 'react-hot-toast';

// const Forgotlogin = () => {
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleForgotPasswordRequest = async (values, resetForm) => {
//     setLoading(true);
//     try {
//       const requestData = {
//         EmployeeCode: values.usercode,
//         EmployeeEmailID: values.mailid,
//         LicenseKey: values.license,
//       };
//       const result = await ForgotPasswordRequest(requestData);

//       if (result?.Status === "Y") {
//         toast.success(result.Msg || "OTP sent successfully!");
//         resetForm();
//         navigate('/#');
//       } else {
//         toast.error(result?.Msg || "Failed to send OTP.");
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       toast.error("Something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       className='wrapper'
//       height="100vh"
//       width="100%"
//       display="flex"
//       justifyContent="center"
//       alignItems="center"
//       // sx={{
//       //   background: 'linear-gradient(to right, #e3f2fd, #fff)',
//       //   position: 'relative'
//       // }}
//     >
//       <IconButton sx={{ position: "absolute", top: 20, right: 20 }} color={'info'}>
//         <HelpOutlineOutlinedIcon />
//       </IconButton>

//       <Grid container justifyContent="center">
//         <Formik
//           initialValues={{ usercode: '', mailid: '', license: '' }}
//           enableReinitialize
//           validationSchema={basicSchema}
//         >
//           {({
//             values, errors, touched, handleBlur, handleChange, resetForm
//           }) => (
//             <form>
//               <Paper elevation={6} sx={{
//                 p: 4,
//                 width: { xs: '90vw', sm: '400px' },
//                 borderRadius: 3,
//                 backgroundColor: '#fff',
//               }}>
//                 <Stack spacing={3}>
//                   <Typography variant="h5" textAlign="center" fontWeight={600}>
//                     Forgot Password
//                   </Typography>

//                   <TextField
//                     label="User Code"
//                     id="usercode"
//                     name="usercode"
//                     value={values.usercode}
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                     error={!!touched.usercode && !!errors.usercode}
//                     helperText={touched.usercode && errors.usercode}
//                     fullWidth
//                     required
//                     autoFocus
//                   />

//                   <TextField
//                     label="Email ID"
//                     id="mailid"
//                     name="mailid"
//                     value={values.mailid}
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                     error={!!touched.mailid && !!errors.mailid}
//                     helperText={touched.mailid && errors.mailid}
//                     fullWidth
//                     required
//                   />

//                   <TextField
//                     label="Subscription Code"
//                     id="license"
//                     name="license"
//                     value={values.license}
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                     error={!!touched.license && !!errors.license}
//                     helperText={touched.license && errors.license}
//                     fullWidth
//                     required
//                   />

//                   <Stack direction="row" justifyContent="space-between" spacing={2}>
//                     <LoadingButton
//                       variant="contained"
//                       color="primary"
//                       fullWidth
//                       loading={loading}
//                       onClick={() => handleForgotPasswordRequest(values, resetForm)}
//                     >
//                       Send OTP
//                     </LoadingButton>
//                     <Button
//                       variant="outlined"
//                       color="secondary"
//                       fullWidth
//                       onClick={resetForm}
//                     >
//                       Cancel
//                     </Button>
//                   </Stack>
//                 </Stack>
//               </Paper>
//             </form>
//           )}
//         </Formik>
//       </Grid>
//     </Box>
//   );
// };

// export default Forgotlogin;
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Stack,
  Grid,
  TextField,
  Button,
  Box,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Typography,
  Paper,
  Card,
  FormControlLabel,
  Checkbox,
  Link,
} from "@mui/material";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Formik } from 'formik';
import { LoadingButton } from '@mui/lab';
import '../../index.css';
import basicSchema from "./validation";
import { ForgotPasswordRequest } from '../../store/reducers/LoginReducer';
import toast from 'react-hot-toast';
// import background from "../../assets/img/ESS_final.png";
import background from "../../assets/img/ESS_CoverImg1.png";
import { styled } from "@mui/system";
import * as Yup from "yup";

const FlexBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

const JustifyBox = styled(FlexBox)(() => ({
  justifyContent: "center",
}));

const ContentBox = styled(Box)(({ theme }) => ({
  height: "100%",
  padding: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    minHeight: "100vh",
    justifyContent: "center",
  },
}));

const JWTRoot = styled(JustifyBox)(({ theme }) => ({
  minHeight: "90vh",
  "& .card": {
    width: "100%",
    minHeight: "90vh",
    display: "flex",
    // borderRadius: 12,
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      boxShadow: "none",
      borderRadius: 0,
      minHeight: "90vh",
    },
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f5f9fa",
    borderRadius: "8px",
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#00796b",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#00796b",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#666",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#00796b",
  },
}));

const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  backgroundColor: "#f5f9fa",
  borderRadius: "8px",
  "& fieldset": {
    borderColor: "#e0e0e0",
  },
  "&:hover fieldset": {
    borderColor: "#00796b",
  },
  "&.Mui-focused fieldset": {
    borderColor: "#00796b",
  },
}));


const LoginButton = styled(LoadingButton)(({ theme }) => ({
  // backgroundColor: "#00796b",
  background: "#0A4063",
  background: "radial-gradient(circle, rgba(10, 64, 99, 1) 40%, rgba(6, 128, 150, 1) 100%)",
  color: "#ffffff",
  padding: "12px 0",
  borderRadius: "8px",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "none",
  // "&:hover": {
  //   backgroundColor: "#00695c",
  // },
  "&:hover": {
    background: "radial-gradient(circle, rgba(10, 64, 99, 1) 40%, rgba(6, 128, 150, 1) 100%)",
  },

  "& .MuiCircularProgress-root": {
    color: "#ffffff",
  },
}));


const Forgotlogin = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    usercode: Yup.string().required("Please enter the User Code"),
    mailid: Yup.string().required("Please enter the Email ID"),
    license: Yup.string().required("Please enter the Subscription Code"),
  });
  const handleForgotPasswordRequest = async (values, resetForm) => {
    setLoading(true);
    try {
      const requestData = {
        EmployeeCode: values.usercode,
        EmployeeEmailID: values.mailid,
        LicenseKey: values.license,
      };
      const result = await ForgotPasswordRequest(requestData);

      if (result?.Status === "Y") {
        toast.success(result.Msg || "OTP sent successfully!");
        resetForm();
        navigate('/#');
      } else {
        toast.error(result?.Msg || "Failed to send OTP.");
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <JWTRoot>
      <Card
        className="card"
        sx={{
          width: "100%",
          boxShadow: { xs: "none", sm: 3 },
          borderRadius: { xs: 0, sm: 0 },

          // ✅ Add this
          backgroundImage: {
            xs: `url(${background})`,
            sm: "none",
          },
          backgroundSize: {
            xs: "cover",
            sm: "unset",
          },
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <Grid container sx={{ height: "100vh" }}>
          <Grid item sm={7} xs={12}>
            <ContentBox
              sx={{
                mx: "auto",
                width: "100%",
                maxWidth: { xs: "95%", sm: 420 },
                // px: { xs: 2, sm: 6 },
                // py: { xs: 4, sm: 6 },
                paddingRight: { xs: 2, sm: 6 },
                paddingLeft: { xs: 1, sm: 6 },
                paddingTop: { xs: 0, sm: 0 },
                paddingBottom: { xs: 0, sm: 0 },
                backgroundColor: "#ffffff",
                // ✅ Transparent on xs so background shows
                backgroundColor: {
                  xs: "rgba(255,255,255,0.85)",
                  sm: "#ffffff",
                },
                backdropFilter: {
                  xs: "blur(15px)",
                  sm: "none",
                },

              }}
            >
              {/* Header */}
              <Box mb={2}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "20px", sm: "30px" },
                    fontWeight: 600,
                    // mb: 0.5,

                    // background: "linear-gradient(180deg, rgba(10,64,99,1) 53%, rgba(6,128,150,1) 100%)",
                    background: "linear-gradient(180deg,rgba(10, 64, 99, 1) 37%, rgba(6, 128, 150, 1) 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    color: "transparent",
                    textAlign: "center"
                  }}
                >
                  Forgot Password ?
                </Typography>
              </Box>



              <Formik
                initialValues={{ usercode: '', mailid: '', license: '' }}
                enableReinitialize
                // validationSchema={basicSchema}
                validationSchema={validationSchema}
              >
                {({
                  values, errors, touched, handleBlur, handleChange, resetForm
                }) => (
                  <form>

                    <Stack spacing={2}>
                      <StyledTextField
                        label="User Code"
                        id="usercode"
                        name="usercode"
                        value={values.usercode}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.usercode && !!errors.usercode}
                        helperText={touched.usercode && errors.usercode}
                        fullWidth
                        // required
                        autoFocus
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Box sx={{ color: "#999", fontSize: "20px" }}>#</Box>
                            </InputAdornment>
                          ),
                        }}
                      />

                      <StyledTextField
                        label="Email ID"
                        id="mailid"
                        name="mailid"
                        value={values.mailid}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.mailid && !!errors.mailid}
                        helperText={touched.mailid && errors.mailid}
                        fullWidth
                        // required
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Box sx={{ color: "#999", fontSize: "20px" }}>#</Box>
                            </InputAdornment>
                          ),
                        }}
                      />

                      <StyledTextField
                        label="Subscription Code"
                        id="license"
                        name="license"
                        value={values.license}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.license && !!errors.license}
                        helperText={touched.license && errors.license}
                        fullWidth
                        // required
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Box sx={{ color: "#999", fontSize: "20px" }}>#</Box>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          mt: 1,
                        }}
                      >
                        <Link
                          onClick={() => navigate(-1)}
                          sx={{
                            // color: "#00796b",
                            color: "#608dcb",
                            fontSize: "14px",
                            cursor: "pointer",
                            textDecoration: "none",
                            "&:hover": {
                              textDecoration: "underline",
                            },
                          }}
                        >
                          Back
                        </Link>
                      </Box>
                      <LoginButton
                        variant="contained"
                        // color="primary"
                        fullWidth
                        loading={loading}
                        onClick={() => handleForgotPasswordRequest(values, resetForm)}
                        sx={{ mt: 3 }}
                      >
                        Send OTP
                      </LoginButton>
                      {/* <Button
                          variant="outlined"
                          color="secondary"
                          fullWidth
                          onClick={resetForm}
                        >
                          Cancel
                        </Button> */}
                    </Stack>

                  </form>
                )}
              </Formik>
            </ContentBox>
          </Grid>

          {/* Right Side: Image */}
          <Grid
            item
            sm={5}
            xs={false}
            sx={{
              display: { xs: "none", sm: "flex" },
              alignItems: "center", // CHANGED: Added to center vertically
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                backgroundImage: `url(${background})`,
                // backgroundSize: "cover",
                backgroundSize: "contain",
                backgroundSize: "100% 100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                // height: "100%",
                height: "98vh",
                minHeight: "100vh",
                width: "100%",
              }}

            />
          </Grid>
        </Grid>

      </Card>
    </JWTRoot >
  );
};

export default Forgotlogin;
